// src/components/Dashboard.js
import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Graph from '../components/Graph';



const Dashboard = () => {
    return (
        <>
            <div className="main-content">
                <Navbar />
            </div>
            <div className="content">
                <Sidebar />
            </div>
            <div className='table-dashboard'>
                <Graph />
            </div>
        </>
    );
};

export default Dashboard;
